module.exports = __webpack_public_path__ + "img/3_x12.9424fc66.png";